<template>
  <b-container fluid="md">
    <h1 class="mt-2">Clients</h1>
    <div class="my-2 d-flex justify-content-between align-items-center">
      <div class="d-flex">
        <b-form-input
          v-model="search"
          size="sm"
          placeholder="Filtrer..."
        ></b-form-input>
        <b-button
          :disabled="search.length == 0"
          variant="info"
          size="sm"
          class="ml-2"
          @click="search = ''"
          >Annuler</b-button
        >
      </div>
      <div>
        <router-link
          tag="button"
          class="btn btn-sm btn-primary"
          :to="{ name: 'ClientNew' }"
          >Ajouter un client</router-link
        >
      </div>
    </div>

    <b-table
      outlined
      :items="list"
      :fields="fields"
      sort-by="name"
      primary-key="_id"
      head-variant="light"
    >
      <template #cell(_id)="data">
        <router-link
          :to="{ name: 'Client', params: { clientId: data.value } }"
          >{{ data.value }}</router-link
        >
      </template>

      <template #cell(name)="data">
        <router-link
          :to="{ name: 'Client', params: { clientId: data.item._id } }"
          class="text-nowrap"
          >{{ data.value }}</router-link
        >
      </template>

      <template #cell(authorized)="data">
        <b-badge v-if="data.value == true" variant="success">Oui</b-badge>
        <b-badge v-else variant="danger">Non</b-badge>
      </template>

      <template #cell(nbActiveRooms)="data">
        <span
          :class="
            data.item.nbRooms < data.value ? 'text-danger' : 'text-success'
          "
          class="font-weight-bold"
          >{{ data.value }}</span
        >
        <!-- <b-badge :variant="data.item.nbRooms < data.value ? 'warning' : 'success'">{{ data.value }}</b-badge> -->
      </template>

      <template #cell(dataLanguages)="data">
        <b-badge
          v-for="code in (data.value || [])"
          :key="code"
          variant="info"
          class="mr-1"
        >{{ getLanguageLabel(code) }}</b-badge>
      </template>

      <template #cell(actions)="data">
        <div class="d-flex">
          <b-button
            v-if="data.item.authorized == true"
            size="sm"
            variant="warning"
            @click="disableClient(data.item)"
            >Désactiver</b-button
          >
          <b-button
            v-else
            type="button"
            size="sm"
            variant="success"
            @click="enableClient(data.item)"
            >Activer</b-button
          >
          <b-button
            size="sm"
            variant="danger"
            class="ml-1"
            @click="deleteClient(data.item)"
            >Supprimer</b-button
          >
        </div>
      </template>
    </b-table>

    <router-link
      tag="button"
      class="btn btn-sm btn-block btn-primary mb-4"
      :to="{ name: 'ClientNew' }"
      >Ajouter un client</router-link
    >
  </b-container>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'Client',
    data() {
      return {
        clients: [],
        search: '',
        availableLanguages: [],
      }
    },
    computed: {
      headers() {
        return {
          Authorization: 'Bearer ' + this.token,
        }
      },
      fields() {
        return [
          // {
          //     key: '_id',
          //     label: '#',
          //     sortable: true,
          //     sortDirection: 'asc',
          //     tdClass: 'text-center font-weight-bold',
          // },
          {
            key: 'name',
            label: 'Nom',
            sortable: true,
            thClass: 'text-center',
            // tdClass: 'text-center',
          },
          {
            key: 'authorized',
            label: 'Autorisé',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'siren',
            label: 'SIREN',
            sortable: true,
            thClass: 'text-center',
            // tdClass: 'text-center',
          },
          {
            key: 'nbRooms',
            label: 'Salles déclarées',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'nbActiveRooms',
            label: 'Salles actives',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'dataLanguages',
            label: 'Langues',
            sortable: false,
            thClass: 'text-center',
          },
          {
            key: 'actions',
            label: '',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
        ]
      },
      list() {
        return this.clients.filter((client) => {
          let isFiltered = true

          if (this.search && this.search.trim().length > 0) {
            let keywords = this.search.trim().split(' ')

            isFiltered = keywords.every((keyword) => {
              return client.name.toLowerCase().includes(keyword.toLowerCase())
            })

            if (!isFiltered && client.mail) {
              isFiltered = keywords.every((keyword) => {
                return client.mail.toLowerCase().includes(keyword.toLowerCase())
              })
            }

            if (!isFiltered && client.phone) {
              isFiltered = keywords.every((keyword) => {
                return client.phone
                  .toLowerCase()
                  .includes(keyword.toLowerCase())
              })
            }
          }
          return isFiltered
        })
      },
    },
    components: {},
    methods: {
      deleteClient(client) {
        this.redirectIfNotLogged()

        if (
          confirm(
            'Voulez-vous vraiment supprimer le client "' + client.name + '" ?'
          ) === false
        )
          return

        axios
          .delete('/client/' + client._id, {
            withCredentials: true,
            headers: this.headers,
          })
          .then(() => {
            let index = this.clients.indexOf(client)
            this.clients.splice(index, 1)

            this.$notify({
              type: 'success',
              title: 'Client supprimé',
            })
          })
          .catch((err) => {
            this.$notify({
              type: 'error',
              title: 'Erreur',
              text:
                err.response.data.message ||
                'Une erreur est survenue durant la suppression du client',
            })
          })
      },
      enableClient(client) {
        client.authorized = true

        this.saveClient(client._id, {
          authorized: client.authorized,
        })
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Client activé',
            })
          })
          .catch((err) => {
            console.log(err)

            this.$notify({
              type: 'error',
              title: 'Erreur',
              text: err.response.data.message || 'Une erreur est survenue',
            })
          })
      },
      disableClient(client) {
        client.authorized = false

        this.saveClient(client._id, {
          authorized: client.authorized,
        })
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Client désactivé',
            })
          })
          .catch((err) => {
            console.log(err)

            this.$notify({
              type: 'error',
              title: 'Erreur',
              text: err.response.data.message || 'Une erreur est survenue',
            })
          })
      },
      saveClient(id, data) {
        this.redirectIfNotLogged()

        return axios.patch('/api/client/' + id, data, {
          withCredentials: true,
          headers: this.headers,
        })
      },
      getLanguageLabel(code) {
        const lang = this.availableLanguages.find((l) => l.code === code)
        return lang ? lang.label : code
      },
      redirectIfNotLogged() {
        const token = localStorage.getItem('jwt')
        if (!token) {
          this.$router.push('/login')
        }
      },
    },
    mounted() {
      this.token = localStorage.getItem('jwt')
      this.redirectIfNotLogged()

      axios
        .get('/api/language', {
          withCredentials: true,
          headers: this.headers,
        })
        .then((response) => {
          this.availableLanguages = response.data
        })
        .catch((err) => {
          console.error('Failed to fetch languages:', err.message)
        })

      axios
        .get('/api/client', {
          withCredentials: true,
          headers: this.headers,
        })
        .then((response) => {
          this.clients = response.data
        })
        .catch(() => {
          this.$router.push('/login')
        })
    },
  }
</script>

<style>
  .container {
    margin-top: 2%;
  }

  a {
    color: black;
  }

  .addClient {
    text-align: center;
  }

  .warningClient {
    color: red;
    font-weight: bold;
  }
</style>
